import { SearchableSelect } from '@/shared/components'
import { ENROLLMENT_SUPPORT_PHONE } from '../../../constants/enrollmentContent'
import { licenseStates } from '../states'
import { formatLicenseNumber } from './helpers'

type LicenseIdentityFieldsProps = {
  driverLicenseState: string
  driverLicenseNumber: string
  isDriverLicenseStateDisabled?: boolean
  isDriverLicenseNumberDisabled?: boolean
  licenseStateMismatchWarning?: string
  onDriverLicenseStateChange: (value: string) => void
  onDriverLicenseNumberChange: (value: string) => void
}

export function LicenseIdentityFields({
  driverLicenseState,
  driverLicenseNumber,
  isDriverLicenseStateDisabled = false,
  isDriverLicenseNumberDisabled = false,
  licenseStateMismatchWarning,
  onDriverLicenseStateChange,
  onDriverLicenseNumberChange
}: LicenseIdentityFieldsProps) {
  return (
    <>
      <div
        className="animate-fade-in-up relative z-[12000]"
        style={{ animationDelay: '120ms' }}
      >
        <SearchableSelect
          label="Driver's License State"
          options={licenseStates}
          value={driverLicenseState}
          onChange={onDriverLicenseStateChange}
          placeholder="Select state"
          disabled={isDriverLicenseStateDisabled}
          required
        />
      </div>
      {licenseStateMismatchWarning ? (
        <p className="mt-2 text-sm text-amber-700">
          {licenseStateMismatchWarning} Please call{' '}
          <a href={ENROLLMENT_SUPPORT_PHONE.href} className="font-medium text-primary underline">
            {ENROLLMENT_SUPPORT_PHONE.display}
          </a>{' '}
          for more details.
        </p>
      ) : null}

      <div className="animate-fade-in-up" style={{ animationDelay: '200ms' }}>
        <label className="enrollment-field-label">Driver License Number *</label>
        <p className="mb-1 text-[11px] italic text-gray-400">System strips special characters</p>
        <input
          type="text"
          placeholder="System strips special characters"
          value={driverLicenseNumber}
          onChange={event => {
            onDriverLicenseNumberChange(formatLicenseNumber(event.target.value))
          }}
          disabled={isDriverLicenseNumberDisabled}
          inputMode="text"
          autoCapitalize="characters"
          maxLength={20}
          required
          className="enrollment-field-control"
        />
      </div>
    </>
  )
}
